export const DRAFT_MAX_WIDTH = 627;

export const STATS_MAX_WIDTH = 400;

export const POSTS_LIMIT = 20;

export const DEFAULT_GEO = { '225': 'Россия' };

export const DEFAULT_REGION_ID = '225';

export const TITLE = 'Продвижение контента';

export const MIN_WEEKLY_LIMIT_VALUE = 300;
